import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import axios from 'axios'

import OrdersView from './View'
import { fetchCities } from 'store/modules/cities/actions'
import { API_URL } from 'src/config'

const mapStateToProps = state => ({
  authToken: state.user.authToken,
  cities: state.cities.data,
  hasOrder: state.orders.has_order,
})

export default connect(
  mapStateToProps
)(UserOrdersContainer)

function UserOrdersContainer({
  authToken,
  cities,
  hasOrder,
}) {
  const dispatch = useDispatch()
  const [orders, setOrders] = useState(null)
  const [ordersOther, setOrdersOther] = useState(null)
  const [isLoaded, setIsLoaded] = useState(null)

  useEffect(() => {
    const cities = dispatch(fetchCities())
    const orders = axios({
      method: 'get',
      url: `${API_URL}/order/`,
      headers: {
        'Authorization': `Token ${authToken}`
      }
    })
    const ordersOther = axios({
      method: 'get',
      url: `${API_URL}/order/another`,
      headers: {
        'Authorization': `Token ${authToken}`
      }
    })

    Promise.all([orders, ordersOther, cities])
    .then(([ordersRes, ordersOtherRes]) => {
      setOrders(ordersRes.data)
      setOrdersOther(ordersOtherRes.data)
      setIsLoaded(true)
    }).catch(err => {
      console.error(err)
    })
  }, [authToken])

  if (!isLoaded) {
    return null
  }

  return <OrdersView
    orders={orders}
    ordersOther={ordersOther}
    cities={cities}
    hasOrder={hasOrder}
  />
}
